export default "__VITE_ASSET__de874d27__"